export const API_BASE = "https://temple.deltronixtech.com/public"; // your PHP API base
//export const API_BASE = "http://localhost:80/plain-php-retail/public"; // your PHP API base
export const STRIPE_PUBLISHABLE_KEY = "pk_test_YOUR_PUBLISHABLE_KEY"; // replace with your key
export const SUCCESS_URL = window.location.origin + "/success";
export const CANCEL_URL = window.location.origin + "/pricing";
export const PLAYLIST_URL = API_BASE + "/api.php?action=playlist&screen_key=test";
